<template>
  <div class="group-management-container">
    <div class="menu-router-container">
      <third-router-nav />
      <div class="simple-menu-right">
        <el-button type="success" icon="el-icon-plus" @click="addUser">
          新增
        </el-button>
        <el-upload
          class="upload-demo"
          action
          :show-file-list="false"
          :http-request="uploadSectionFile"
          :before-upload="beforeAvatarUpload"
          multiple
        >
          <el-button type="warning">
            导入
          </el-button>
        </el-upload>
      </div>
    </div>
    <div v-loading="loading" class="menu-stores">
      <div class="stores-contain">
        <div class="simple-menu">
          <simple-search :search-data="searchData" :is-unwind="false" @child-event="getSearch" @child-close="getReset" />
        </div>
        <div class="user-table">
          <table-people
            :table-data="tableData"
            :table-headers="tableHeaders"
            :is-page="true"
            :border="false"
            :total="total"
            :page="current"
            :page-size="size"
            :page-sizes="[5, 10, 25, 50, 100]"
            :page-background="false"
            page-layout="total, sizes, prev, pager, next, jumper"
            page-position="right"
            @currentPage="currentPage"
            @sizeChange="sizeChange"
          >
            <template slot="avatar" slot-scope="scope">
              <div class="heard-icon">
                <img :src="scope.row.avatar ? scope.row.avatar : avatarImage" class="table-more-icon">
              </div>
            </template>
            <template slot="companyVoList" slot-scope="scope">
              <p v-for="(item, index) in scope.row.companyVoList" :key="index">
                {{ item.companyName }} ({{ item.isCompanyAdmin === 1 ? '管理员' : '普通员工' }})
              </p>
            </template>
            <template slot="options" slot-scope="scope">
              <div class="operation">
                <div class="operation-btn edit-btn" @click="goEdit(scope.row)">
                  编辑
                </div>
                <div class="operation-btn-delete" @click="goDel(scope.row.userId)">
                  删除
                </div>
              </div>
            </template>
          </table-people>
        </div>
      </div>
    </div>
    <popup title="提示" :show.sync="show" :content="popupContent" confirm-button-text="确 定" background="#FF645F" @toTrue="toTrue" />
    <user-management ref="miniprogramForm" @fresh="getReset" />
  </div>
</template>

<script>
import SimpleSearch from '@/components/search/SimpleSearch'
import TablePeople from '@/components/table/TablePeople'
import Popup from '@/components/popup/Popup'
import UserManagement from './user-management-form'
import ThirdRouterNav from '@/components/dashboard/ThirdRouterNav'
import { userGetPage, sysCompanyPage, deleteUser, importExcel, getLoginInfo } from '@/api/index'
import avatarImage from '@/assets/images/avatar.png'
export default {
  components: {
    SimpleSearch,
    TablePeople,
    Popup,
    UserManagement,
    ThirdRouterNav
  },
  data() {
    return {
      avatarImage,
      searchData: [
        { name: '姓名', field: 'nickName', type: 'text' },
        { name: '手机号码', field: 'phone', type: 'number' },
        { name: '所属公司', field: 'companyIdList', type: 'select', hide: false,
          props: { multiple: true, collapseTags: true, filterable: true },
          options: []
        }
      ],
      size: 10,
      current: 1,
      total: 0,
      tableHeaders: [
        { prop: 'avatar', label: '头像' },
        { prop: 'nickName', label: '姓名', options: [{ type: 'sort' }] },
        { prop: 'phone', label: '手机号码', options: [{ type: 'sort' }] },
        { prop: 'email', label: '邮箱', options: [{ type: 'sort' }] },
        { prop: 'companyVoList', label: '所属公司', options: [{ type: 'sort' }] },
        { prop: 'options', label: '操作', width: 200 }
      ],
      tableData: [],
      show: false,
      loading: false,
      popupContent: '',
      searchParams: {},
      userId: ''
    }
  },
  mounted() {
    this.getUserGetPage()
    this.getLoginInfoData()
  },
  methods: {
    getLoginInfoData() {
      getLoginInfo().then((res) => {
        if (res.data.role.indexOf(1) !== -1) {
          this.getSysCompanyPage()
        } else {
          this.searchData[2].hide = true
        }
      })
    },
    getSysCompanyPage() {
      const data = {
        current: 1,
        size: 9999
      }
      sysCompanyPage(data).then((res) => {
        this.searchData[2].options = res.data.records.map(item => {
          return { label: item.companyName, value: item.id }
        })
      })
    },
    /**
     * 删除接口
     * */
    getDeleteUser() {
      deleteUser(this.userId).then((res) => {
        if (res.code === 0) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getUserGetPage()
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    getUserGetPage() {
      this.loading = true
      const data = {
        current: this.current,
        size: this.size,
        ...this.searchParams
      }
      userGetPage(data).then((res) => {
        this.loading = false
        if (res.code === 0) {
          this.total = res.data.total
          this.tableData = res.data.records
        }
        // 在删除时候判断
        if (this.total > 0 && this.current > 1 && this.tableData.length === 0) {
          this.current -= 1
          this.getUserGetPage()
        }
      }).finally(result => {
        this.loading = false
      })
    },
    // 查询
    getSearch(data) {
      console.log(data)
      this.current = 1
      this.size = 10
      const param = {}
      Object.keys(data).map(key => {
        data[key] && (param[key] = data[key])
      })
      this.searchParams = param
      this.getUserGetPage()
      console.log(data)
    },
    // 重置
    getReset() {
      this.current = 1
      this.size = 10
      this.searchParams = {}
      this.getUserGetPage()
    },
    // 新增用户
    addUser() {
      this.$refs.miniprogramForm.init()
      console.log('新增用户')
    },
    // 分页页数改变
    currentPage(page) {
      this.current = page
      this.getUserGetPage()
    },
    /**
     * 分页大小改变
     * */
    sizeChange(size) {
      this.size = size
      this.getUserGetPage()
    },
    // 编辑
    goEdit(row = {}) {
      this.$refs.miniprogramForm.init(row)
    },
    // 删除
    goDel(id) {
      this.popupContent = '是否删除？'
      this.show = true
      this.userId = id
    },
    // 点击确定弹窗
    toTrue() {
      this.show = false
      this.getDeleteUser()
    },
    // 接口
    uploadSectionFile(param) {
      const formData = new FormData()
      formData.append('file', param.file)
      // 接口
      importExcel(formData).then(res => {
        if (res.code === 0) {
          this.current = 1
          this.size = 10
          this.searchParams = {}
          if (res.data) {
            window.location.href = res.data
          } else {
            this.$message({
              type: 'success',
              message: '导入成功!'
            })
          }
          this.getUserGetPage()
        } else {
          this.$message.error('导入文件不规范，请检查文件！')
        }
      }).finally(result => {
        this.loading = false
      }).catch(err => {
        this.$message.error('导入文件不规范，请检查文件！')
        console.log(err)
      })
    },

    // 上传图片之前
    beforeAvatarUpload(file) {
      this.loading = true
      const isLt2M = file.size / 1024 / 1024 < 2
      const isXls = /\.(xlsx|xls|XLSX|XLS)$/.test(file.name)
      if (!isXls) {
        this.$message.error('上传图片只能是 xlsx 或者 xls格式!')
      } else {
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!')
        }
      }
      return isXls && isLt2M
    }
  }
}
</script>

<style lang="scss" scoped>
.group-management-container {
  background-color: #fff;
  width: 100%;
  flex: 1;
  .menu-router-container {
    display: flex;
    justify-content: space-between;
    background-color: #ebeeef;
    .simple-menu-right {
      width: 200px;
      margin-right: 40px;
      display: flex;
      justify-content: flex-end;
      .el-button {
        height: 32px;
        line-height: 32px;
        padding: 0 10px;
        margin-left: 15px;
      }
    }
  }
  .menu-stores {
    padding: 20px;
  }
  .simple-menu {
    background: rgba(247, 249, 251, 1);
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    .simple-menu-left {
      width: calc(100% - 300px);
    }
  }
  .user-table {
    width: 100%;
    margin-top: 30px;
    .heard-icon{
      width: 30px;
      height: 30px;
      border-radius: 50%;
      >img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .disable-btn {
      color: #999999;
    }
    .edit-btn {
      color: #E6A23C;
    }
    .del-btn {
      color: #FF3939;
    }
  }
  .upload-menu {
    ::v-deep .el-dialog {
      width: 400px;
    }
  }
}
</style>
